import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Cookies from "universal-cookie";
import Header from '../../components/header/Header';
import ViewSwitcher from '../../components/ViewSwitcher';
import importedIcons from '../../components/inputs/icons';
import HttpServices from '../../utils/Http.services';
import StagesManager from '../../components/StagesManager';
import PageViewer from '../PageViewer';
import { SettingsFrames } from '../../variables/AppletPages';
import { checkDefaultTab, userCheckDefaultTab } from '../../utils/useful';
import DriveUserView from './DriveUserView';
import MessengerView from '../../components/views/messenger/MessengerView';
import MessengerUserView from './MessengerUserView';

class CollectionBaseUserView extends Component {

    state = {
        showBackBtn: false,
        showToolbar: false,
        headerConfig: {
            showToolbar: false, showSettings: false, showSettings: false,
        },
        page: {},
        headers: [],
        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            participation: { key: "participation", label: '{{lang}}Open Quiz', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openNewWindow", icon: importedIcons.edit },
        },
    }



    componentDidMount() {
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            // this.init()
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }
        if (this.props.defaultHeaderConfig) {
            this.setState({ headerConfig: this.props.defaultHeaderConfig })
        }
    }
    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                let accessPages = this.props.frames ?? Object.values(SettingsFrames.pages)
                let accessSections = this.props.framesSections ?? Object.values(SettingsFrames.sections)

                // console.log(this.props.applet)
                // console.log(accessPages)
                // console.log(accessSections)
                // console.log("accessPages",this.props.frames)

                this.setState({ modules: accessPages, sections: accessSections, oldData: this.props.windowData }, () => {
                    this.checkDefaultTab()
                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }

    componentDidUpdate(prevProps) {
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
        if ((JSON.stringify(this.props.frames) != JSON.stringify(prevProps.frames))) {
            let accessPages = this.props.frames
            let accessSections = this.props.framesSections


            // console.log("accessPages", accessPages)
            this.setState({ modules: accessPages, sections: accessSections, oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
    }

    goToAdmin = (applet) => {
        let path = [applet.hub?.username, applet.slug, 'admin']

        // console.log(path)
        // return
        this.props.changeWindow('applet', { path: path })
    }


    checkDefaultTab() {
        // console.log('*checkDefaultTab', this.state.modules, this.state.sections)

        let windowData = JSON.parse(JSON.stringify(this.props.windowData))
        // console.log(this.props.applet?.defaultPage)
        // console.log(this.props.applet)

        if (!this.props.applet?.defaultPage?._id) {
            this.goToAdmin(this.props.applet)
            return
        }

        if (this.props.baseUrl?.length == windowData?.path.length && this.props.applet?.defaultPage?._id) {
            windowData?.path.push(this.props.applet?.defaultPage?._id)
        }

        this.setState({ windowData }, () => {
            // console.log(this.props.baseUrl, windowData)

            // console.log(this.state.modules)

            checkDefaultTab(windowData, this.props.baseUrl, this.state.modules, this.props.width, (pageInfo, pageType, def) => {
                // userCheckDefaultTab(windowData, this.props.baseUrl, this.props.applet, this.state.modules, this.props.width, (pageInfo, pageType, def) => {

                // console.log('checkDefaultTabcb', pageInfo, pageType, def)

                def = def ?? ''
                pageType = pageType != null ? pageType : def
                // console.log('pageTypepp', pageType)
                if (pageType != null) {
                    this.setState({ oldData: this.props.windowData, path: def, pageType: pageType }, () => {
                        setTimeout(() => {
                            this.setState({ page: pageInfo, pageType, headers: pageInfo?.fields ?? pageInfo?.headers, pageStatus: 200 }, () => {
                                let variables = this.state.variables ?? {}
                                if (pageInfo && pageInfo.relatedFrame) {
                                    variables.frameId = pageInfo.relatedFrame
                                }

                                // console.log("pageType", pageType)
                                this.setState({ variables })
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                    })
                                }
                            })
                        }, 10);
                    })
                } else {
                    this.setState({ pageStatus: 404 })
                }
            })
        })
    }
    functionsHandler = (type, name, data, extra) => {
        if (this[name]) {
            this[name](data, extra)
        }
    }
    openNewWindow = (prop, extra) => {
        // console.log('object', prop, extra)
        let fullPath = [...this.props.baseUrl, prop._id]
        let data = { type: 'applet', path: fullPath }
        this.props.changeWindow('applet', data)
        this.stageManager.changeStage('page')

    }
    init = () => {
        // console.log('this.props.applet.frame', this.props.applet.frames[0].frame)
        // console.log('this.props.applet.frame', this.props.frames)
        let page = {}
        let headers = []
        let frames = this.props.frames
        if (Array.isArray(frames)) {
            frames.forEach(element => {
                if (element.type == 'collection' && element._id == this.props.applet.frames[0].frame._id) {
                    element.key = element._id
                    element.section = 'collections'
                    element.pageType = 'collection'
                    element.fetchUrl = 'getRecords'
                    element.addUrl = 'postRecord'
                    element.editUrl = 'updateRecord'
                    element.removeUrl = 'removeRecord'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.customAdd = { title: '{{lang}}Edit Quiz', function: 'addInquiry', functionInput: 'addRule' }
                    element.customEdit = { title: '{{lang}}Add Rule', function: 'editInquiry', functionInput: 'addRule' }
                    element.fields.forEach(field => {
                        if (!field.key.includes("values.")) {
                            field.key = "values." + field.key
                        }
                    });
                    headers = JSON.parse(JSON.stringify(element.fields))
                    page = JSON.parse(JSON.stringify(element))

                }
            });
        }
        // console.log("page, headers", page, headers)
        this.setState({ page, headers }, () => {
            this.fetchData()
        })

    }
    setHeader = (key, value) => {

        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: false,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }

                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'CollectionBaseUserView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }
    changePage = (page, info) => {
        let extraPath = Array.isArray(page) ? page : [page]
        let fullPath = [...this.props.baseUrl, ...extraPath]

        // console.log("changePage",fullPath)
        this.changeWindow(fullPath, info)
    }



    changeWindow = (list, info) => {
        // console.log(list, info)
        if (Array.isArray(list)) {

            // console.log(this.props.baseUrl)
            let finalList = [...this.props.baseUrl]

            list.forEach(value => {
                let one = value
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                } 
                if (one) {
                    finalList.push(one) 
                }
            });
            let data = { type: 'applet', path: finalList }
            if (info) {
                data.params = info
            }

            // console.log("data", data)
            // return
            this.props.changeWindow('applet', data)
        }
    }




    changeStage = (stage) => {
        this.stageManager.changeStage(stage)
    }
    fetchData = (getCount, filter) => {
        this.setState({ isLoadingData: true })
        let body = this.state.page.filter ? { ...this.state.page.filter } : {}
        let page = this.state.page
        body.limit = this.state.limit
        body.skip = this.state.currentPage
        // body.page = page.key
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }
        if (this.state.totalCount == null || getCount) {
            body.getCount = true
        }
        body.frame = this.state.page?._id
        body.filter = filter

        // console.log(filter)
        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {

            console.log(fetchResult, fetchError)

            this.setState({ isLoadingData: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            this.setState({ showTable: false }, () => {
                this.setState({ data: fetchResult.info, showTable: true }, () => {
                    // let keys = ["values.d78c13e6-bbc8-48bc-8ab4-ff22cbb9c06c", "values.d7caac63-ed2e-454b-aaec-8c06c26e0da4", "values.92e053a5-6f21-4e77-b7c2-638749485a33"]
                })
            })
            if (fetchResult.count != null) {
                this.setState({ totalCount: fetchResult.count })
            }
        })
    }
    changeValue = (value) => {
        let tempValue = value
        this.setState({ tempValue }, () => {
        })
    }

    selectApplet = () => {

    }







    render() {

        // console.log(this.props.width)
        // console.log('CollectionBaseUserView', this.state.page)
        return (
            <div className='d-flex w-100 h-100 window-content-radius BaseAdminView' style={{ display: 'block', backgroundColor: '#fff' }}>
                <div className={" w-100 h-100 d-flex flex-column " + (this.props.isDesktop ? "window-content-radius" : "")} ref={el => this.pageContainer = el} style={{}} >
                    <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} userPerspective={true} />
                    </div>

                    <StagesManager height={'0px'} className={'flex-1'} ref={el => this.stageManager = el} fast={true}>

                        <PageViewer stage={1} userView={this.props.userView}
                            stageName={'page'} baseUrl={this.props.baseUrl}
                            variables={this.props.variables} colors={this.props.colors}
                            frames={this.props.frames} framesSections={this.props.framesSections} changeWindowLink={this.changeWindow} width={this.props.width} functionsHandler={this.functionsHandler} height={this.props.height} setHeader={this.setHeader}
                            windowData={this.state.windowData} route={this.props.rootUrl} applet={this.props.applet}
                            connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                            addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                            goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.changeWindow} page={this.state.page} />


                        <DriveUserView currentApplet={this.state.currentApplet} width={this.props.width} page={this.state.page}
                            isApplet={true} userView={this.props.userView} stageName={'drive'} baseUrl={[...this.props.baseUrl]}
                            variables={this.props.variables} colors={this.props.colors} frames={this.props.frames}
                            framesSections={this.props.framesSections} changeWindowLink={this.changeWindow}
                            functionsHandler={this.functionsHandler} height={this.props.height} setHeader={this.setHeader}
                            windowData={this.state.windowData} route={this.props.rootUrl} applet={this.props.applet}
                            connection={this.props.connection} user={this.props.user} setUser={this.props.setUser} changePage={this.changePage}
                            addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                            goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.changeWindow}
                        />



                        <MessengerUserView currentApplet={this.state.currentApplet} width={this.props.width} page={this.state.page}
                            isApplet={true} userView={this.props.userView} stageName={'messenger'} baseUrl={[...this.props.baseUrl]}
                            variables={this.props.variables} colors={this.props.colors} frames={this.props.frames}
                            framesSections={this.props.framesSections} changeWindowLink={this.changeWindow}
                            functionsHandler={this.functionsHandler} height={this.props.height} setHeader={this.setHeader}
                            windowData={this.state.windowData} route={this.props.rootUrl} applet={this.props.applet}
                            connection={this.props.connection} user={this.props.user} setUser={this.props.setUser} changePage={this.changePage}
                            addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                            goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.changeWindow} selectApplet={this.selectApplet}
                        />
                        {/*                         
                        <MessengerView currentApplet={this.state.currentApplet} width={this.props.width} page={this.state.page}
                            isApplet={true} userView={this.props.userView} stageName={'messenger'} baseUrl={[...this.props.baseUrl]}
                            variables={this.props.variables} colors={this.props.colors} frames={this.props.frames}
                            framesSections={this.props.framesSections} changeWindowLink={this.props.changeWindowLink}
                            functionsHandler={this.functionsHandler} height={this.props.height} setHeader={this.setHeader}
                            windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                            connection={this.props.connection} user={this.props.user} setUser={this.props.setUser} changePage={this.changePage}
                            addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                            goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} selectApplet={this.selectApplet}
                        /> */}

                    </StagesManager>
                    {/* <CollectionView userView={true} stageName={'collection'} isMobile={this.props.isMobile} permissions={this.props.permissions} changeWindow={this.changeWindow} changePage={this.changePage} ref={el => this.collectionView = el} setData={this.setData} setHeader={this.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} modules={this.state.modules} formPages={this.state.page?.formPages} page={this.state.page} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} applet={this.props.applet} headers={this.state.headers} automations={this.state.automations} language={this.props.language} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} goToHub={this.props.goToHub} variables={this.props.variables} functionsHandler={this.functionsHandler} /> */}

                    {/* <PageViewer permissions={this.props.permissions} ref={el => this.collectionView = el} windowData={this.props.windowData} setData={this.setData} setHeader={this.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} formPages={this.props.applet?.page?.page} changePage={this.changePage} page={this.props.applet?.page?.page} baseUrl={[...this.props.baseUrl]} applet={this.props.applet} headers={this.state.headers} automations={this.state.automations} language={this.props.language} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} goToHub={this.props.goToHub} variables={this.props.variables} /> */}

                    {/* <StagesManager height={'0px'} className={'flex-1'} ref={el => this.stageManager = el} fast={true}>
                    </StagesManager> */}
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CollectionBaseUserView);